<template>
    <ModalComponent
        :name="'borrar-' + codigo.id"
        :title="'¿Seguro que quieres borrar el código: ' + codigo.codigo + '?'"
        v-on:close="() => close(false)"
    >
        <div class="row">
            <div class="col-12 text-center">
                <h1 class="font-weight-bold">¿BORRAR CÓDIGO?</h1>
            </div>
            <div class="col-12 text-center">
                <Button type="button" name="button" @click="borrarCodigo">SI, BORRAR</Button>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['codigo'],
        data() {
            return {
                loading: false
            }
        },
        methods: {
            close(borrado) {
                this.$emit('close', 'borrar-' + this.codigo.id, borrado);
            },
            borrarCodigo() {
                this.loading = true;

                var params = {
                    lista_id: this.lista_id,
                    categoria_id: this.$route.params.categoria_id,
                    codigo_id: this.codigo.id,
                    filters : {}
                }

                this.$store.dispatch(this.config.getVuexAlias('back.bases.categorias.codigos_invitacion.borrar'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.$emit('terminado');
                    this.close(true);
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            }
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
